import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: "student-personal-details",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-student-personal-details" */ "./components"
    ).then(m => m.default)
  ),

  childRoutes: [],
});
